import { USER_INFO } from '../actions';
import { getCurrentUserInfo } from '../../helpers/Utils';

let INIT_STATE = getCurrentUserInfo();

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case USER_INFO:
      INIT_STATE = action.payload;
      return { ...state, ...action.payload };

    default:
      return { ...state };
  }
};
